import { render } from "./HighPriorityAlerts.vue?vue&type=template&id=bf711a68"
import script from "./HighPriorityAlerts.vue?vue&type=script&lang=js"
export * from "./HighPriorityAlerts.vue?vue&type=script&lang=js"

import "./HighPriorityAlerts.vue?vue&type=style&index=0&id=bf711a68&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__